import { createComponent } from '../../Foundation';
import { TextView } from './Text.view';
import { TextStyles as styles } from './Text.styles';
export var Text = createComponent(TextView, {
    displayName: 'Text',
    styles: styles,
});
export default Text;
//# sourceMappingURL=Text.js.map